import { useState, useEffect } from "react";
import FolderView from "./FolderView";

const DirectoryView = (props: DirectoryViewProps) => {
  const createRootDirectory = () => {
    const root: directory = {
      type: "DIRECTORY",
      name: "Assets",
      isRoot: true,
      path: "",
      children: [],
    };

    for (const asset of props.assets) {
      const split = asset.name.split("/");
      const fileName = split.pop();
      const joinedPath = split.join("/");
      const currentPath: string[] = [];
      let currentDirectory = root;

      while (split.length > 0) {
        const folder = split.shift();

        currentPath.push(folder);
        const path = currentPath.join("/");

        const found = currentDirectory.children.find((child: any) => {
          return child.type === "DIRECTORY" && child.path === path;
        });

        if (found) {
          currentDirectory = found;
          continue;
        }

        currentDirectory.children.push({
          type: "DIRECTORY",
          name: folder,
          path: path,
          isRoot: false,
          children: [],
        });

        currentDirectory = currentDirectory.children.find(
          (child: any) => child.type === "DIRECTORY" && child.path === path
        );
      }

      currentDirectory.children.push({
        type: "FILE",
        name: fileName,
        path: joinedPath,
        asset: asset,
      });
    }
    return root;
  };

  const [currentDirectory, setCurrentDirectory] = useState<any>(
    createRootDirectory()
  );
  const [parentDirectories, setParentDirectories] = useState<any[]>([]);

  // Update currentDirectory whenever props.assets change
  useEffect(() => {
    const newRoot = createRootDirectory();
    setCurrentDirectory(newRoot);
    setParentDirectories([]); // Reset parent directories on assets change
  }, [props.assets]);

  const handleDirectorySelection = (directoryPath: string) => {
    const found = currentDirectory.children.find((child: any) => {
      return child.type === "DIRECTORY" && child.path === directoryPath;
    });
    if (found) {
      setParentDirectories(parentDirectories.concat(currentDirectory));
      setCurrentDirectory(found);
    }
  };

  const handleDirectoryBack = () => {
    const finalIndex = parentDirectories.length - 1;
    const parentDirectory = parentDirectories[finalIndex];
    setParentDirectories(parentDirectories.slice(0, finalIndex));
    setCurrentDirectory(parentDirectory);
  };

  return (
    <FolderView
      currentDirectory={currentDirectory}
      parentDirectories={parentDirectories}
      handleDirectorySelection={handleDirectorySelection}
      handleBack={handleDirectoryBack}
      setSelectedImage={props.setSelectedImage}
      selectedImageUrl={props.selectedImage}
      assets={props.assets}
      updateAssets={props.updateAssets}
      isBannerImageSelectModal={props.isBannerImageSelectModal}
    />
  );
};

interface DirectoryViewProps {
  assets: any[];
  setSelectedImage?: (url: string) => void;
  selectedImage?: string;
  updateAssets: (updatedAssets: any[]) => void;
  isBannerImageSelectModal?: boolean;
}

interface directory {
  type: string;
  name: string;
  path: string;
  isRoot: boolean;
  children: any[];
  selectedImageUrl?: string;
}

export default DirectoryView;
